import * as React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDeleteJobCardMutation } from "../api/apiSlice";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Typography from "@mui/material/Typography";

export default function AbortJobButton() {
  const { job_card_reference_id } = useParams();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [deleteJobCard, { isSuccess }] = useDeleteJobCardMutation();

  useEffect(() => {
    if (isSuccess) navigate("/installer/");
  }, [isSuccess, navigate]);

  const handleConfirm = () => {
    deleteJobCard({ body: { reference_id: job_card_reference_id } });
  };

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        disableElevation
        sx={{
          flex: 1,
          py: "13px",
          borderRadius: "10px",
          backgroundColor: "#0d1117",
          color: "#e0e6f0",
          fontSize: "1rem",
          fontWeight: 600,
          textTransform: "none",
          border: "1px solid rgba(255,255,255,0.12)",
          "&:hover": { backgroundColor: "#161b22" },
        }}
      >
        Abort
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            backgroundColor: "#1A1C24",
            borderRadius: "16px",
            border: "1px solid rgba(255,255,255,0.07)",
            mx: 2,
          },
        }}
      >
        <DialogContent>
          <Typography sx={{ fontSize: "1.1rem", fontWeight: 700, color: "#fff", mb: 1 }}>
            Abort this installation?
          </Typography>
          <DialogContentText sx={{ fontSize: "0.88rem", color: "rgba(255,255,255,0.55)" }}>
            This cannot be undone. The job card will be permanently deleted.
          </DialogContentText>
          <DialogContentText sx={{ fontSize: "0.82rem", color: "rgba(255,255,255,0.4)", mt: 1 }}>
            You'll be returned to the dashboard. Contact your supervisor to log a fault and create a new job card for this site.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 2, pb: 2, gap: 1 }}>
          <Button
            onClick={() => setOpen(false)}
            fullWidth
            sx={{
              backgroundColor: "rgba(255,255,255,0.06)",
              color: "#fff",
              borderRadius: "10px",
              fontWeight: 700,
              py: 1.2,
              "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
            }}
          >
            Back
          </Button>
          <Button
            onClick={handleConfirm}
            fullWidth
            sx={{
              backgroundColor: "#ef4444",
              color: "#fff",
              borderRadius: "10px",
              fontWeight: 700,
              py: 1.2,
              "&:hover": { backgroundColor: "#dc2626" },
            }}
          >
            Confirm Abort
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
